import type { SxProps, Theme } from '@mui/material/styles'
import { densityPx } from '@/theme/base/density'

/** Écart horizontal entre le popover compte et les sous-panneaux (Floating UI `offset` mainAxis). */
export const accountSubpopoverMainAxisGapPx = densityPx(12)

/** Hauteur / alignement communs pour Compte, Langue, Thème dans le popover compte */
export const accountPopoverMenuRowSx: SxProps<Theme> = {
  borderRadius: 1,
  px: 1,
  py: 0,
  minHeight: densityPx(35),
  display: 'flex',
  alignItems: 'center',
}
